module.exports = __webpack_public_path__ + "media/bootstrap-icons/code-dc90d5d5.svg";